import React, { useState } from 'react';
import { X, BookOpen, ChevronRight, Zap, Mail, BarChart3, Users, Shield, Brain, HelpCircle, ArrowRight, CheckCircle, GitBranch, Truck, Factory, Lock } from 'lucide-react';
import SectionContent from './user-manual/SectionContent';

const SECTIONS = [
  { id: 'prozessfluss', title: 'Prozessfluss (E2E)', icon: GitBranch },
  { id: 'intro', title: 'Einführung', icon: BookOpen },
  { id: 'quickstart', title: 'Schnellstart', icon: Zap },
  { id: 'login', title: 'Login & Navigation', icon: Shield },
  { id: 'create', title: 'Reklamation erstellen', icon: ChevronRight },
  { id: 'workflow', title: '8D/4D-Workflow', icon: ArrowRight },
  { id: 'ai', title: 'KI-Funktionen', icon: Brain },
  { id: 'q2', title: 'Q2 Lieferant', icon: Truck },
  { id: 'q3', title: 'Q3 Werk-intern', icon: Factory },
  { id: 'email', title: 'E-Mail-Reklamationen', icon: Mail },
  { id: 'dashboard', title: 'Dashboard & Analytics', icon: BarChart3 },
  { id: 'roles', title: 'Rollen (12)', icon: Users },
  { id: 'admin', title: 'Benutzerverwaltung', icon: Users },
  { id: 'security', title: 'Sicherheit & Audit', icon: Lock },
  { id: 'tips', title: 'Best Practices', icon: CheckCircle },
  { id: 'faq', title: 'FAQ & Hilfe', icon: HelpCircle },
];

export function UserManualPanel({ isOpen, onClose }) {
  const [activeSection, setActiveSection] = useState('prozessfluss');
  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 z-[70] bg-black/30" onClick={onClose} />
      <div className="fixed top-0 right-0 z-[70] h-full w-full sm:w-[72vw] lg:w-[65vw] shadow-2xl flex flex-col overflow-hidden bg-white" style={{ borderLeft: '1px solid #e2e8f0' }} data-testid="user-manual-panel">
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-3 border-b border-slate-200 bg-white">
          <div className="flex items-center gap-2">
            <BookOpen className="w-4 h-4 text-blue-600" />
            <h2 className="font-bold text-sm text-slate-800">Benutzerhandbuch</h2>
            <span className="text-[10px] px-1.5 py-0.5 rounded-full font-semibold bg-blue-100 text-blue-700">v1.0</span>
          </div>
          <button onClick={onClose} className="p-1.5 rounded-lg hover:bg-slate-100 transition-colors" data-testid="close-manual-btn"><X className="w-4 h-4 text-slate-500" /></button>
        </div>
        {/* Navigation Tabs */}
        <div className="flex overflow-x-auto px-3 py-2 gap-1 border-b border-slate-200 bg-slate-50">
          {SECTIONS.map(s => {
            const isActive = s.id === activeSection;
            return (
              <button key={s.id} onClick={() => setActiveSection(s.id)}
                className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[11px] whitespace-nowrap transition-all flex-shrink-0 ${isActive ? 'font-semibold bg-blue-100 text-blue-700 shadow-sm' : 'text-slate-500 hover:text-slate-700 hover:bg-slate-100'}`}
                data-testid={`manual-nav-${s.id}`}>
                <s.icon className="w-3 h-3" />{s.title}
              </button>
            );
          })}
        </div>
        {/* Content */}
        <div className="flex-1 overflow-y-auto p-5 bg-white" data-testid="manual-content"><SectionContent id={activeSection} /></div>
        {/* Footer */}
        <div className="px-4 py-2 border-t border-slate-200 text-[10px] text-slate-400 text-center bg-white">QM8D.ai — Benutzerhandbuch v1.0</div>
      </div>
    </>
  );
}
